import React, { useRef } from 'react'
import { Bar } from 'react-chartjs-2'
import { Box, Grid, Paper, Skeleton, Typography } from '@mui/material'
import '../../../styles/report.css'
import RectangleIcon from '@mui/icons-material/Rectangle';
import { selectViewInstanceById } from '../../../reducers/reuseable_vi';
import { useSelector } from 'react-redux';
import viewinstance from '../../../reducers/viewinstance';

const RYGGLegend = (props) => {
    const Variant = props.variant
    const takeAction = props.takeAction ? true : false
    const showScore = props.showScore ? true : false
    const rygColors = ['#209D70', '#FEC957', '#E6323A', '#c0c0c0']
    const royggColors = ['#E6323A', '#FE9350', '#FEC957', '#6CDE6C', '#209D70']
    const viewInstance = useSelector(state => selectViewInstanceById(state, 'ReportLegend'))
    
    const StandardColors = () => {
        const RYGG = viewInstance && viewInstance.status === 'success' && viewInstance?.LegendsVI?.RYGG
        return (
            
            
            <Grid container direction="row" alignItems="row" justifyContent="center" spacing={2}>

                {RYGG.map((obj, idx) => {
                    return (
                        <Grid item xs={6} md={3} key={"rygg_" + idx}>
                            <Grid container direction="row" alignItems="row" justifyContent="center" spacing={2}>
                                <Grid item xs={3} justifyContent="end">
                                    <Typography align="right">
                                        <RectangleIcon fontSize='medium' sx={{ color: obj.Color }} />
                                    </Typography>
                                </Grid>
                                <Grid item xs={9} justifyContent="start">
                                    <Typography variant="caption" align="left">{obj.Label}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    )
                })}


            </Grid>
        )
    }

    const FiveColors = () => {
        return (


            <Grid container columns={15} direction="row" alignItems="row" justifyContent="center" spacing={2}>
                {
                    props.FiveColors.map((x, i) => {
                        return (
                            <Grid item xs={12} md={3}>
                                <Grid container direction="row" alignItems="row" justifyContent="center" spacing={2}>
                                    <Grid item xs={3} justifyContent="end">
                                        <Typography align="right">
                                            <RectangleIcon fontSize='medium' sx={{ color: x.Color }} />
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={9} justifyContent="start">
                                        <Typography variant="caption" align="left">{x.Label}</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )
                    })
                }

            </Grid>
        )
    }
    if (viewInstance && viewInstance?.status === 'success') {

        return (
            <Box px={4}>
                {Variant === 'FIVE COLOR' ? <FiveColors /> : <StandardColors />}
            </Box>
        )
    } else {
        return (
            <Paper elevation={1}>
                <Skeleton variant="rectangular" animation="wave" sx={{ paddingTop: "10%" }} height={0} />
            </Paper>
        )
    }

}

export default RYGGLegend